import Subheading from 'components/Subheading';
import WeeklyDrawNumberPicker from 'components/WeeklyDrawNumberPicker';
import PopupWithDimmedBackground from 'components/PopupWithDimmedBackground';
import React from 'react';
import { colors } from 'utils/constants';

interface IWeeklyDrawNumberPickerPopup {
  showPopup: boolean;
  prepopulateMainNumbers: number[];
  prepopulateBonusNumbers: number[];
  numberRanges: number[];
  bonusNumberRanges: number[];
  onConfirmNumbers: (mainNumbers: number[], bonusNumbers: number[]) => void;
  onClose: () => void;
  glowColor: string;
}

const WeeklyDrawNumberPickerPopup = ({
  showPopup,
  prepopulateMainNumbers,
  prepopulateBonusNumbers,
  numberRanges,
  bonusNumberRanges,
  onConfirmNumbers,
  onClose,
  glowColor,
}: IWeeklyDrawNumberPickerPopup) => {
  if (!showPopup) {
    return null;
  }

  return (
    <PopupWithDimmedBackground
      additionalClassName="weeklyDrawNumberPickerPopup"
      onClose={onClose}
    >
      <Subheading>
        Choose <strong>numbers</strong>
      </Subheading>

      <WeeklyDrawNumberPicker
        prepopulateMainNumbers={prepopulateMainNumbers}
        prepopulateBonusNumbers={prepopulateBonusNumbers}
        numberRanges={numberRanges}
        bonusNumberRanges={bonusNumberRanges}
        glowColor={glowColor}
        onConfirmNumbers={(mainNumbers: number[], bonusNumbers: number[]) => {
          onConfirmNumbers(mainNumbers, bonusNumbers);
          onClose();
        }}
      />

      <div
        className="cancelButton"
        onClick={onClose}
      >
        Cancel
      </div>

      <style jsx>
        {`
          .cancelButton {
            font-weight: 700;
            color: ${colors.primaryBrandGray}80;
            cursor: pointer;
          }
        `}
      </style>
    </PopupWithDimmedBackground>
  );
};

export default WeeklyDrawNumberPickerPopup;
